/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  BusinessMemoryContentScopeNode,
  BusinessMemoryContentScopeNode$inboundSchema,
} from "./businessmemorycontentscopenode.js";

export type ListBusinessMemoryContentScopesResponseBody = {
  /**
   * Namespace and exact-tag nodes in lexical order.
   */
  nodes: Array<BusinessMemoryContentScopeNode>;
  /**
   * Total number of active memories, including memories without a content scope.
   */
  totalMemories: number;
};

/** @internal */
export const ListBusinessMemoryContentScopesResponseBody$inboundSchema:
  z.ZodMiniType<ListBusinessMemoryContentScopesResponseBody, unknown> = z.pipe(
    z.object({
      nodes: z.array(BusinessMemoryContentScopeNode$inboundSchema),
      total_memories: z.int(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "total_memories": "totalMemories",
      });
    }),
  );

export function listBusinessMemoryContentScopesResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  ListBusinessMemoryContentScopesResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListBusinessMemoryContentScopesResponseBody$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListBusinessMemoryContentScopesResponseBody' from JSON`,
  );
}
